import { StateWrapper } from "./styles";
import {
  facilityTableHeaders,
  facilityTableKeys,
  getFacilityTableData,
  secretariatCards,
} from "./data";
import { LargeCard } from "../stats/subs/LargeCard";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import { useCallback, useMemo, useState } from "react";
import { KeyValueObj } from "@/common/types";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useNavigate } from "react-router-dom";

const StateDashboard = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const [facilityPerpage, setFacilityPerpage] = useState(10);
  const navigate = useNavigate();

  const {
    data: facilityData,
    meta: facilityMeta,
    loading: facilityLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${facilityPerpage}&page=${facilityPerpage}`
  );

  const handleDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleFacilityView = useCallback(() => {
    // update active row ID
    navigate("/dashboard/state-sec/fund-allocation/drf/1");
  }, []);

  const facilityDropdowns = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleFacilityView }]
        : [{ label: "View", action: handleFacilityView }],
    [handleFacilityView, currentRow]
  );

  return (
    <StateWrapper>
      <div className="card-wrapper">
        {secretariatCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={facilityTableHeaders}
          tableKeys={facilityTableKeys}
          tableData={getFacilityTableData(facilityData)}
          tableTitle="DRF Facilities"
          loading={facilityLoading}
          handleDropDownClicked={handleDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={facilityDropdowns}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={facilityMeta?.total_pages}
          onNextPage={(event: any) => setFacilityPerpage(event.selected)}
          onPerPageChange={(event: any) =>
            setFacilityPerpage(event?.target?.value)
          }
        />
      </div>
    </StateWrapper>
  );
};

export default StateDashboard;
